import { hot } from "react-hot-loader/root";
import React from "react";
import { i18n } from "../utils/utils";
import { Speed } from "@sparkpost/matchbox-icons";
import Section from "./Section";

const SendingProgress = ({ progress }) => {
  let progressBarWidth = (progress.current * 100) / progress.max;

  if (progressBarWidth > 100) {
    progressBarWidth = 100;
  }

  progressBarWidth = Math.round(progressBarWidth);

  let progressBarClass = ["progress-bar"];

  if (progress.current > progress.max) {
    progressBarClass.push("overflow");
  } else if (progress.current === progress.max) {
    progressBarClass.push("full");
  } else if (progressBarWidth < 100 && progressBarWidth > 85) {
    progressBarClass.push("almost");
  }

  return (
    <Section className="section-sending-limit">
      <div className="section-inner">
        <Speed size={32} color="#1273e6" />
        <h3>{i18n("Text.SendingLimit")}</h3>
        <p className="numbers">
          {progress.current} / {progress.max}
        </p>
        <div className={progressBarClass.join(" ")}>
          <div
            className="progresser"
            style={{ width: `${progressBarWidth}%` }}
          ></div>
        </div>
        <a
          href="https://wpmailpro.com/pricing?upgrade=true"
          target="_blank"
          className="upgrade-button"
        >
          {i18n("Text.Upgrade")}
        </a>
      </div>
    </Section>
  );
};
export default hot(SendingProgress);
